// External Imports
import sanitizeHtml from 'sanitize-html';

// Internal Imports
import { hostnameRegex } from '../config/pathRegex.js';
import { languageCodesArray } from '../config/types/language.js';

// Local Functions
const isAnchorLink = (url) => url[0] === '#';
const magazineUrlRegex = hostnameRegex
  .toString()
  .replace('$', `/(${languageCodesArray.join('|')})/magazine/`);
// Stripping away the `/` at the beginning and end of the stringified regexp asthe RegExp constructor doesn't handle them
const isMagazineUrl = (url) => new RegExp(magazineUrlRegex.slice(1, -1)).test(url);

const removeLinks = (articleContent) => {
  if (!articleContent.includes('<a')) {
    return articleContent;
  }

  return sanitizeHtml(articleContent, {
    // Don't filter out any attributes
    allowedAttributes: false,
    // Don't filter out any tags
    allowedTags: false,
    allowVulnerableTags: true,
    transformTags: {
      a(tagName, attribs) {
        const { target, ...attributesWithoutTarget } = attribs;
        if (!attributesWithoutTarget.href) {
          // Render the tag as-is but without a "target" attribute
          return { attribs: attributesWithoutTarget, tagName };
        }

        const { href } = new URL(attributesWithoutTarget.href, window.location.href);
        if (isAnchorLink(href) || isMagazineUrl(href)) {
          // Render the tag as-is but without a "target" attribute
          return { attribs: attributesWithoutTarget, tagName };
        }

        // Convert to a <span> with no attributes
        return { tagName: 'span' };
      },
    },
  });
};

// Module Exports
export { removeLinks };
